<template>
    <o-form :title="$t('core.user')" :url="'/api/system/users/' + $route.params.id + '?include=roles,approval_roles,regions'"
            class="ortic-form-horizontal" ref="form" @loaded="loaded">
        <template slot-scope="props">
            <b-row>
                <b-col>
                    <o-input :errorField="'name'" :label="$t('core.name')" v-model="props.item.name"/>
                    <o-input :label="$t('core.first_name')" v-model="props.item.first_name"/>
                    <o-input :label="$t('core.second_name')" v-model="props.item.second_name"/>
                    <o-input :errorField="'email'" :label="$t('core.email')" v-model="props.item.email"/>
                    <o-input :errorField="'phone'" :label="$t('core.phone')" v-model="props.item.phone"/>
                    <b-alert show>{{$t('sandoz.title_hint')}}</b-alert>
                    <o-input :errorField="'title'" :label="$t('sandoz.title')" v-model="props.item.title"/>
                    <o-value-select :label="$t('sandoz.language')" :items="languages"
                                  v-model="props.item.language"></o-value-select>
                    <hr>
                    <o-input :errorField="'password'" :label="$t('core.password')" type="password"
                             v-model="props.item.password"/>
                    <div class="text-danger mb-3 text-center" v-if="'password' in $root.errors">
                      <div v-for="error in $root.errors.password">
                        {{error}}
                      </div>
                    </div>
                    <b-alert show>{{ $t('sandoz.password_hint') }}</b-alert>
                    <o-checkbox :label="$t('core.active')" v-model="props.item.active"></o-checkbox>
                    <hr>
                    <o-checkbox :label="$t('core.super_user')" v-model="props.item.is_super_user"></o-checkbox>
                    <o-role v-model="props.item.roles" :label="$t('core.roles')"
                            :url="'/api/system/roles?per_page=' + Number.MAX_SAFE_INTEGER"></o-role>

                    <o-checkbox :label="$t('core.is_kam_user')" v-model="props.item.is_kam_user"></o-checkbox>
                    <o-checkbox :label="$t('core.is_enable_2fa')" v-model="props.item.is_enable_2FA"></o-checkbox>
                    <o-checkbox :label="$t('core.enforce_2a')" v-model="props.item.enforce_2a"></o-checkbox>

                    <div class="form-group">
                      <label>{{ $t('core.region') }} </label>
                      <div class="w-100">
                        <b-form-radio-group
                          id="regions"
                          v-model="regions"
                          :options="regionRadio"
                          @change="setRegion"
                          name="regions">
                        </b-form-radio-group>
                      </div>
                    </div>
                </b-col>
                <b-col>
                    <b-alert show>{{$t('sandoz.notification_hint')}}</b-alert>
                    <o-checkbox :label="$t('core.receive_system_notification')" v-model="props.item.receive_system_notification"></o-checkbox>
                    <o-checkbox :label="$t('sandoz.receive_service_notification')" v-model="props.item.receive_service_notification"></o-checkbox>
                    <template v-if="props.item.receive_system_notification || props.item.receive_service_notification">
                        <o-value-select :label="$t('core.notification_channel')" :items="notificationChannels"
                                        v-model="props.item.notification_channel"></o-value-select>
                        <o-input v-if="props.item.notification_channel == 'telegram'" :errorField="'telegram_chat_id'" :label="$t('core.telegram_chat_id')"
                                 v-model="props.item.telegram_chat_id"/>
                    </template>
                    <hr>
                    <b-alert show>{{$t('sandoz.key_hint')}}</b-alert>
                    <o-input :label="$t('sandoz.key')" v-model="props.item.key"/>
                    <hr>
                    <b-alert show>{{$t('sandoz.user_relation_hint')}}</b-alert>
                    <o-value-select :label="$t('sandoz.parent_user')" url="/api/system/users?sortBy=name" value-field="id" text-field="name"
                                  v-model="props.item.parent_user"></o-value-select>
                    <o-value-select :label="$t('sandoz.replacement_user')" url="/api/system/users?sortBy=name" value-field="id" text-field="name"
                                  v-model="props.item.replacement_user_id"></o-value-select>
                    <hr>
                    <b-alert show>{{$t('sandoz.approval_hint')}}</b-alert>
                    <!--
                    <o-value-select :label="$t('sandoz.approval_role')" :items="roles"
                                  v-model="props.item.approval_role"></o-value-select>
                    <o-value-select :label="$t('sandoz.approval_role_type')" :items="types"
                                  v-model="props.item.approval_role_type"></o-value-select>
                    -->
                    <o-value-select :label="$t('sandoz.approval_notification_queue')" :items="approvalNotificationQueues"
                                  v-model="props.item.approval_notification_queue"></o-value-select>

                    <table class="table table-sm">
                      <thead>
                        <tr>
                          <th>{{$t('sandoz.approval_role')}}</th>
                          <th>{{$t('sandoz.approval_role_type')}}</th>
                          <th>{{$t('core.region')}}</th>
                          <th>{{$t('sandoz.is_deputy')}}</th>
                          <th class="text-right">
                            <b-btn @click.prevent="$refs.addApprovalRole.show()" variant="primary" size="sm">
                              <fa icon="plus"/>
                            </b-btn>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(approvalRole, approvalRoleIndex) in props.item.approval_roles" :key="approvalRoleIndex">
                          <td>{{approvalRole.approval_role}}</td>
                          <td>{{approvalRole.approval_role_type}}</td>
                          <td>{{ findRegion(approvalRole.region_id) }}</td>
                          <td>{{approvalRole.is_deputy ? $t('sandoz.yes') : $t('sandoz.no')}}</td>
                          <td class="text-right">
                            <b-btn @click.prevent="props.item.approval_roles.splice(approvalRoleIndex, 1)" variant="secondary" size="sm">
                              <fa icon="times"/>
                            </b-btn>
                          </td>
                        </tr>
                      </tbody>
                    </table>

                    <b-modal id="modal-add-approval-role" ref="addApprovalRole" :title="$t('sandoz.add_approval_role')" @ok="addRole">
                      <b-alert show>{{$t('sandoz.add_approval_hint')}}</b-alert>
                      <o-value-select :items="approvalRoles" :label="$t('sandoz.approval_role')" v-model="addApprovalRole.approvalRole"/>
                      <o-value-select :items="approvalRoleTypes" :label="$t('sandoz.approval_role_type')" v-model="addApprovalRole.approvalRoleType"/>
                      <o-value-select :items="regionRadio" :label="$t('core.region')" v-model="addApprovalRole.region_id"/>
                      <o-checkbox v-model="addApprovalRole.isDeputy" :label="$t('sandoz.is_deputy')" />
                    </b-modal>

                    <hr>
                    <b-alert show>{{$t('sandoz.territory_hint')}}</b-alert>
                    <o-value-select :label="$t('sandoz.territory')" url="/api/sandoz/org_territory" value-field="id_territory" text-field="territory_descr"
                                  v-model="props.item.territory_id"></o-value-select>

                </b-col>
            </b-row>
        </template>
    </o-form>
</template>

<script>
  import axios from 'axios'
  export default
  {
    data: () => ({
      notificationChannels: [],
      roles: [],
      types: [],
      languages: [],
      approvalNotificationQueues: [],
      passwordHint: null,
      approvalRoles: [
        {value: 'Head of Market Access', text: 'Head of Market Access'},
        {value: 'Customer Service', text: 'Customer Service'},
        {value: 'Customer Service (4th eye)', text: 'Customer Service (4th eye)'},
        {value: 'FLM', text: 'FLM'},
        {value: 'FLM1', text: 'FLM1'},
        {value: 'FLM2', text: 'FLM2'},
        {value: 'Legal', text: 'Legal'},
        {value: 'Channel Head', text: 'Channel Head'},
        {value: 'Compliance', text: 'Compliance'},
        {value: 'Performance Unit', text: 'Performance Unit'},
        {value: 'BPA', text: 'BPA'},
        {value: 'BU Head Retail', text: 'BU Head Retail'},
        {value: 'CFO', text: 'CFO'},
        {value: 'GM', text: 'GM'},
        {value: 'Medical', text: 'Medical'},
        {value: 'Legal & Compliance', text: 'Legal & Compliance'},
        {value: 'Individual KUKO Approver', text: 'Individual KUKO Approver'},
        {value: 'Buying Group KUKO Approver', text: 'Buying Group KUKO Approver'},
        {value: 'Special Customer KUKO Approver', text: 'Special Customer KUKO Approver'},
        {value: 'Chargeback KUKO Approver', text: 'Chargeback KUKO Approver'},
        {value: 'Marketing', text: 'Marketing'}
      ],
      approvalRoleTypes: [
        {value: '', text: '-'},
        {value: 'APO', text: 'APO'},
        {value: 'APO_ONE', text: 'APO_ONE'},
        {value: 'CNS', text: 'CNS'},
        {value: 'HEIM', text: 'HEIM'},
        {value: 'HOSP', text: 'HOSP'},
        {value: 'KAM', text: 'KAM'},
        {value: 'IMMUNO', text: 'IMMUNO'},
        {value: 'SD', text: 'SD'},
        {value: 'ONCO', text: 'ONCO'},
        {value: 'OTC', text: 'OTC'},
        {value: 'APO_KUKO', text: 'APO_KUKO'},
        {value: 'SD_KUKO', text: 'SD_KUKO'},
        {value: 'IMMUNO_KUKO', text: 'IMMUNO_KUKO'},
        {value: 'HOSP_KUKO', text: 'HOSP_KUKO'},
        {value: 'CNS_KUKO', text: 'CNS_KUKO'},
        {value: 'KAM_APO', text: 'KAM_APO'},
        {value: 'KAM_SD', text: 'KAM_SD'},
        {value: 'KAM_WHS', text: 'KAM_WHS'},
        {value: 'KAM_DIVERSE', text: 'KAM_DIVERSE'},
        {value: 'KAM_DIVERSE_HOSP', text: 'KAM_DIVERSE_HOSP'},
        {value: 'KAM_DIVERSE_INSUR', text: 'KAM_DIVERSE_INSUR'},
        {value: 'Wholesaler', text: 'Wholesaler'},
        {value: 'SD_GADGET', text: 'SD_GADGET'},
        {value: 'CNS_GADGET', text: 'CNS_GADGET'},
        /*{value: 'ONCO_GADGET', text: 'ONCO_GADGET'},*/
        {value: 'IMMUNO_GADGET', text: 'IMMUNO_GADGET'},
        {value: 'KAM_SD_GADGET', text: 'KAM_SD_GADGET'},
        {value: 'APO_GADGET', text: 'APO_GADGET'},
        {value: 'KAM_APO_GADGET', text: 'KAM_APO_GADGET'},
        {value: 'SD_EDU', text: 'SD_EDU'},
        {value: 'CNS_EDU', text: 'CNS_EDU'},
        {value: 'IMMUNO_EDU', text: 'IMMUNO_EDU'},
        {value: 'ONCO_EDU', text: 'ONCO_EDU'},
        {value: 'KAM_SD_EDU', text: 'KAM_SD_EDU'},
        {value: 'APO_EDU', text: 'APO_EDU'},
        {value: 'KAM_APO_EDU', text: 'KAM_APO_EDU'},
        {value: 'SD_SORTALYS', text: 'SD_SORTALYS'},
        {value: 'CNS_SORTALYS', text: 'CNS_SORTALYS'},
        {value: 'IMMUNO_SORTALYS', text: 'IMMUNO_SORTALYS'},
        {value: 'KAM_SD_SORTALYS', text: 'KAM_SD_SORTALYS'},
        {value: 'Market Access', text: 'Market Access'},
        {value: 'BIOS_APO', text: 'BIOS_APO'},
        {value: 'HIGHSPEC_GADGET', text: 'HIGHSPEC_GADGET'},
        {value: 'BIOS_KAM_APO', text: 'BIOS_KAM_APO'},
        {value: 'BIOS_KAM_WHS', text: 'BIOS_KAM_WHS'},
        {value: 'High Specialty', text: 'High Specialty'},
        {value: 'HIGHSPEC_SORTALYS', text: 'HIGHSPEC_SORTALYS'},
        {value: 'APO_OTC', text: 'APO_OTC'},
      ],
      addApprovalRole: {
        approvalRole: null,
        approvalRoleType: '',
        isDeputy: false,
        region_id: null
      },
      regions: null,
      regionRadio: []
    }),

    mounted() {
      this.notificationChannels.push({value: 'email', text: this.$i18n.t('core.email')})
      this.notificationChannels.push({value: 'telegram', text: this.$i18n.t('core.telegram')})

      this.approvalNotificationQueues.push({value: '24h', text: this.$i18n.t('sandoz.queue_24h')})
      this.approvalNotificationQueues.push({value: '8h', text: this.$i18n.t('sandoz.queue_8h')})

      this.getRegions()
    },

    methods: {
      addRole() {
        this.$refs.form.item.approval_roles.push({
          approval_role: this.addApprovalRole.approvalRole,
          approval_role_type: this.addApprovalRole.approvalRoleType,
          is_deputy: this.addApprovalRole.isDeputy,
          region_id: this.addApprovalRole.region_id,
        })
        this.addApprovalRole = {
          approvalRole: null,
          approvalRoleType: '',
          isDeputy: false,
          region_id: null
        }
        this.$refs.addApprovalRole.hide()
      },
      getRegions() {
        axios.get(`/api/system/regions?sortBy=region&per_page=99999`).then((response) => {
          const self = this
          response.data.data.forEach(function (region) {
            self.regionRadio.push({value: region.id, text: region.region})
          })
        }).catch((error) => {
        })
      },
      setRegion() {
        this.$refs.form.item.regions = []
        this.$refs.form.item.regions.push({
          user_id: this.$route.params.id,
          region_id: this.regions,
        })
      },

      loaded(item) {
        if( Object.keys(item.regions).length > 0) {
          this.regions = item.regions[0].region_id
        }
      },

      findRegion(regionID) {
        if(regionID !== null) {
          var filterRadio = this.regionRadio.filter(rradio => {
              return rradio.value === regionID
          })

          if( Object.keys(filterRadio).length > 0) {
            return filterRadio[0].text
          }
        }
        return null;
      }
    },

    created () {
      this.languages = [
        {value: 'en', text: this.$i18n.t('sandoz.english')},
        {value: 'de', text: this.$i18n.t('sandoz.german')},
        {value: 'fr', text: this.$i18n.t('sandoz.french')},
        {value: 'it', text: this.$i18n.t('sandoz.italian')}
      ]

      this.roles = [
        {value: 'FLM', text: this.$i18n.t('sandoz.flm')},
        {value: 'Channel Head', text: this.$i18n.t('sandoz.channel_head')},
        {value: 'BU Head Retail', text: this.$i18n.t('sandoz.bu_head_retail')},
        {value: 'BPA', text: this.$i18n.t('sandoz.bpa')},
        {value: 'CFO', text: this.$i18n.t('sandoz.cfo')},
        {value: 'Customer Service', text: this.$i18n.t('sandoz.customer_service')},
        {value: 'Legal', text: this.$i18n.t('sandoz.legal')},
        {value: 'Compliance', text: this.$i18n.t('sandoz.compliance')},
        {value: 'Performance Unit', text: this.$i18n.t('sandoz.performance_unit')},
        {value: 'BPA', text: this.$i18n.t('sandoz.bpa')},
        {value: 'Legal & Compliance', text: this.$i18n.t('sandoz.legal_compliance')},
      ]

      this.types = [
        {value: 'SD', text: this.$i18n.t('sandoz.sd')},
        {value: 'APO', text: this.$i18n.t('sandoz.apo')},
        {value: 'KAM', text: this.$i18n.t('sandoz.kam')},
        {value: 'ONCO', text: this.$i18n.t('sandoz.onco')},
        {value: 'IMMUNO', text: this.$i18n.t('sandoz.immuno')},
        {value: 'CNS', text: this.$i18n.t('sandoz.cns')},
        {value: 'HEIM', text: this.$i18n.t('sandoz.heim')},
        {value: 'OTC', text: this.$i18n.t('sandoz.otc')},
        {value: 'APO_KUKO', text: this.$i18n.t('sandoz.apo_kuko')},
        {value: 'SD_KUKO', text: this.$i18n.t('sandoz.sd_kuko')},
        {value: 'IMMUNO_KUKO', text: this.$i18n.t('sandoz.immuno_kuko')},
        {value: 'HOSP_KUKO', text: this.$i18n.t('sandoz.hosp_kuko')},
        {value: 'CNS_KUKO', text: this.$i18n.t('sandoz.cns_kuko')},
        {value: 'SD_GADGET', text: this.$i18n.t('sandoz.sd_gadget')},
        {value: 'CNS_GADGET', text: this.$i18n.t('sandoz.cns_gadget')},
        /*{value: 'ONCO_GADGET', text: this.$i18n.t('sandoz.onco_gadget')},*/
        {value: 'IMMUNO_GADGET', text: this.$i18n.t('sandoz.immuno_gadget')},
        {value: 'KAM_SD_GADGET', text: this.$i18n.t('sandoz.kam_sd_gadget')},
        {value: 'APO_GADGET', text: this.$i18n.t('sandoz.apo_gadget')},
        {value: 'KAM_APO_GADGET', text: this.$i18n.t('sandoz.kam_apo_gadget')},
        {value: 'SD_EDU', text: this.$i18n.t('sandoz.sd_edu')},
        {value: 'CNS_EDU', text: this.$i18n.t('sandoz.cns_edu')},
        {value: 'IMMUNO_EDU', text: this.$i18n.t('sandoz.immuno_edu')},
        {value: 'ONCO_EDU', text: this.$i18n.t('sandoz.onco_edu')},
        {value: 'KAM_SD_EDU', text: this.$i18n.t('sandoz.kam_sd_edu')},
        {value: 'APO_EDU', text: this.$i18n.t('sandoz.apo_edu')},
        {value: 'KAM_APO_EDU', text: this.$i18n.t('sandoz.kam_apo_edu')},
        {value: 'HIGHSPEC_GADGET', text: this.$i18n.t('sandoz.highspec_gadget')}
      ]
    }
  }
</script>
